import { SportsbookVm } from './SportsbookVm';
import { BettingSideData } from '../api/types/BettingSideData';
import { GameVm } from './GameVm';
import { TeamVm } from './TeamVm';

export class BettingSideVm {
    constructor(
        bettingSideData: BettingSideData,
        sportsbookVm: SportsbookVm,
        overUnder?: 'over' | 'under' | null // optional constructor arg as the bet may not be a Total
    ) {
        this.sportsbook = sportsbookVm;
        this.overUnder = overUnder || null;
        this.handicap = bettingSideData.handicap;
        this.total = bettingSideData.total;
        this.odds = bettingSideData.odds;
        this.oddsDecimal = bettingSideData.oddsDecimal;
        this.oddsFraction = bettingSideData.oddsFraction;
        this.oddsType = bettingSideData.oddsType;
        this.oddsScope = bettingSideData.oddsScope;
        this.marketValue = bettingSideData.marketValue || null;
    }
    
    sportsbook: SportsbookVm;
    handicap: number | null;
    total: number | null;
    odds: number;
    oddsDecimal: number;
    oddsFraction: string;
    oddsType: string;
    oddsScope: string;
    overUnder: string | null;
    marketValue: string | null; // sharpsports marketid    
}
